import {
  inlineHTMLToJSON,
  inlineJSONToHTML,
} from "../convert";

import {
  deepFindByUID,
  modifyNodeValueByUIDAndKey,
} from "../doc_helpers";

import {
  addStyle,
  removeStyle,
} from "../inline_json";

import {
  isCollapsedRange,
} from "../range";

export function handleStyle<DocContent extends PossibleContent>(
  tagName: StyleType,
  modifyContent: (modifyFunction: ModifyFunction<DocContent>) => void,
  setCurrentlyEditing: (currentlyEditing: CurrentlyEditing | undefined) => void,
  currentlyEditingOverride?: CurrentlyEditing,
) {
  modifyContent((json, currentlyEditing) => {
    const currentSelection = currentlyEditingOverride || currentlyEditing;
    if (!currentSelection) { return json; }

    const currentlyEditingNode = deepFindByUID(json, currentSelection.uid);
    if (!currentlyEditingNode) { return json; }

    let currentlyActiveStyles: Array<StyleRange> = [];
    const editingRange = currentSelection.range;
    if (currentSelection.key && editingRange) {
      const currentlyEditingInlineJSON = inlineHTMLToJSON((currentlyEditingNode as any)[currentSelection.key]);

      currentlyActiveStyles = currentlyEditingInlineJSON.styles.filter((style) => style.range.start <= editingRange.start && style.range.end >= editingRange.end);
    }

    const activeStyle = currentlyActiveStyles?.find((style) => style.type === tagName);
    const newlyActive = currentSelection?.newlyActiveStyles?.find((style) => style.type === tagName);
    const newlyInactive = currentSelection?.newlyInactiveStyles?.find((style) => style.type === tagName);

    if (activeStyle) {
      if (isCollapsedRange(currentSelection.range)) {
        if (newlyInactive) {
          setCurrentlyEditing({...currentSelection,
            newlyInactiveStyles: (currentSelection.newlyInactiveStyles || []).filter((style) => style.type !== tagName),
          });
        } else {
          setCurrentlyEditing({...currentSelection,
            newlyInactiveStyles: (currentSelection.newlyInactiveStyles || []).concat([tagName === "a" ? {type: "a", args: {href: ""}} : {type: tagName}]),
          });
        }
      } else {
        return modifyNodeValueByUIDAndKey(json, currentSelection.uid, currentSelection.key, (inlineHTML: InlineHtmlContent) => {
          return inlineJSONToHTML(removeStyle(inlineHTMLToJSON(inlineHTML), tagName, currentSelection.range));
        });
      }
    } else {
      if (isCollapsedRange(currentSelection.range)) {
        if (newlyActive) {
          setCurrentlyEditing({...currentSelection,
            newlyActiveStyles: (currentSelection.newlyActiveStyles || []).filter((style) => style.type !== tagName),
          });
        } else {
          setCurrentlyEditing({...currentSelection,
            newlyActiveStyles: (currentSelection.newlyActiveStyles || []).concat([tagName === "a" ? {type: "a", args: {href: ""}} : {type: tagName}]),
          });
        }
      } else {
        return modifyNodeValueByUIDAndKey(json, currentSelection.uid, currentSelection.key, (inlineHTML: InlineHtmlContent) => {
          return inlineJSONToHTML(addStyle(inlineHTMLToJSON(inlineHTML), tagName === "a" ? {type: tagName, args: {href: ""}} : {type: tagName}, currentSelection.range));
        });
      }
    }

    return json;
  });
}

